import {useEffect, useState} from 'react';
import {useSearchParams} from "react-router";

const menuDefault = {
    attendance: {
        show: true,
        highlight: false,
        prevShow: true,
        showInMenu: true,
        group: "1",
        filter: []
    },
    garrison: {
        show: true,
        highlight: false,
        prevShow: true,
        showInMenu: true,
        group: "1",
        filter: []
    },
    sos: {
        show: true,
        highlight: false,
        prevShow: false,
        showInMenu: true,
        group: "1"
    },
    janitorial: {
        show: true,
        highlight: false,
        prevShow: true,
        showInMenu: true,
        group: "2"
    },
    capturePlace: {
        show: true,
        highlight: false,
        prevShow: true,
        showInMenu: true,
        group: "2",
        filter: []
    },
    vms: {
        show: true,
        highlight: false,
        prevShow: true,
        showInMenu: true,
        group: "2",
        filter: []
    },
    contactid: {
        show: true,
        highlight: false,
        prevShow: true,
        showInMenu: true,
        group: "2",
        filter: []
    },
    point: {
        show: false,
        highlight: false,
        prevShow: false,
        prevChecked: [],
        showInMenu: true,
        group: "2"
    },
    zone: {
        show: false,
        showInMenu: true,
        group: "2"
    },
    waze: {
        show: true,
        highlight: false,
        prevShow: true,
        showInMenu: true,
        group: "3"
    },
    tracker: {
        show: true,
        highlight: false,
        prevShow: true,
        showInMenu: true,
        group: "3"
    },
    weather: {
        show: true,
        highlight: false,
        prevShow: true,
        showInMenu: true,
        group: "3"
    },
}

const getMenuFromStorage = () => {
    let menuStorage = localStorage.getItem('menuGroup');

    if (menuStorage) {
        menuStorage = JSON.parse(menuStorage);
        return menuStorage
    }

    return menuDefault;
}

const UseMenu = () => {
    const [menu, setMenu] = useState(getMenuFromStorage());
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.has("grid")) {
            setMenu(prev => {
                const grid = searchParams.get("grid").split(",");

                Object.keys(prev).forEach(key => {
                    prev[key].show = grid.includes(key);
                    prev[key].showAll = grid.includes(key);
                })

                return prev
            })
        }
    }, [searchParams]);

    const changeMenu = (newMenu) => {
        setMenu(newMenu);
        localStorage.setItem('menuGroup', JSON.stringify(newMenu))
    }

    return {menu, changeMenu}
};

export default UseMenu;